import { useParams, Link, Navigate } from "react-router-dom";
import s from "../styles/VehicleDetails.module.css";
import Modal from "react-modal";
import { AuthContext } from '../AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from 'react-router-dom';






const VehicleDetails = () => {
  const { id } = useParams(); // Получаем ID машины из URL
  const [vehicle, setVehicle] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null);
  const [photoList, setPhotoList] = useState([]);
  
  const [modalOpen, setModalOpen] = useState(false);
  const { role } = useContext(AuthContext);

  const startX = useRef(null);

  const navigate = useNavigate();

  const [showModal_del, setShowModal_del] = useState(false);


  const [totalSlides, setTotalSlides] = useState(0);    // всего слайдов






  useEffect(() => {
    const fetchVehicle = async () => {
      try {
        const response = await fetch(`/api/vehicles/${id}`);
        if (!response.ok) throw new Error("Ошибка загрузки данных");
        const data = await response.json();
        setVehicle(data);
        // Собираем список всех фото (основные + дефекты)
        if (!data) return; // Защита от null

        // Собираем список всех фото (основные + дефекты)
        const allPhotos = [
          { key: "photo_3_4_front_left_url", label: "¾ спереди слева" },
          { key: "photo_vin_url", label: "VIN" },
          { key: "photo_dashboard_url", label: "Приборная панель" },
          { key: "photo_front_url", label: "Спереди" },
          { key: "photo_rear_url", label: "Сзади" },
          { key: "photo_3_4_rear_right_url", label: "¾ сзади справа" },
          { key: "photo_engine", label: "Двигатель" },
        ]
          .map(({ key, label }) => (data[key] ? { src: `/vehicles/${data[key]}`, label } : null))
          .filter(Boolean); // Убираем null-значения
  
        // Добавляем фото дефектов
        if (Array.isArray(data.photo_defects_urls) && data.photo_defects_urls.length > 0) {
          allPhotos.push(
            ...data.photo_defects_urls.map((url) => ({ src: `/vehicles/${url}`, label: "Дефект" }))
          );
        }

        setPhotoList(allPhotos);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchVehicle();
  }, [id]);






  const [currentIndex, setCurrentIndex] = useState(0);

  const slideWidth = 405; // ширина одного слайда (px)
  const startTouchX = useRef(null);
  
  // Кнопки
  const nextSlide = () => {
    setCurrentIndex(prev => Math.min(prev + 3, photoList.length - 1));
  };
  const prevSlide = () => {
    setCurrentIndex(prev => Math.max(prev - 3, 0));
  };
  
  // Свайпы
  const handleCarouselTouchStart = (e) => {
    startTouchX.current = e.touches[0].clientX;
  };
  const handleCarouselTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = startTouchX.current - endX;
    if (diff > 50) {
      // свайп влево -> next
      nextSlide();
    } else if (diff < -50) {
      // свайп вправо -> prev
      prevSlide();
    }
  };











  const openModal = ( index) => {
    setSelectedPhotoIndex(index);
    setModalOpen(true);
  };

    // Закрытие модального окна
    const closeModal = () => {
      setModalOpen(false);
      setSelectedPhotoIndex(null);
    };

  // Переключение фото
  const nextPhoto = () => {
    setSelectedPhotoIndex((prevIndex) => (prevIndex + 1) % photoList.length);
  };

  const prevPhoto = () => {
    setSelectedPhotoIndex((prevIndex) => (prevIndex - 1 + photoList.length) % photoList.length);
  };

const handleTouchStart = (e) => {
  startX.current = e.touches[0].clientX;
};

const handleTouchEnd = (e) => {
  const endX = e.changedTouches[0].clientX;
  if (startX.current - endX > 50) {
    nextPhoto();
  } else if (endX - startX.current > 50) {
    prevPhoto();
  }
};


  const handleDeleteClick = () => {
    setShowModal_del(true);
  };


    // 📌 Закрытие модального окна
    const handleCloseModal = () => {
      setShowModal_del(false);
    };

// 📌 Удаление автомобиля
const handleDeleteVehicle = async () => {
  

  try {
    const response = await fetch(`/api/vehicles/delete/${vehicle.id}`, {
      method: "DELETE",
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Ошибка при удалении");

    navigate("/");
  } catch (err) {
    setError(err.message);
  }
};

if (loading) return <p>Загрузка...</p>;
if (error) return <p style={{ color: "red" }}>Ошибка: {error}</p>;
if (!vehicle) return <p>Машина не найдена</p>;

  return (
    <div className={s.container}>
      <div className={s.div_pan}>
  <h2 className={s.title}>Детали автомобиля</h2>
       
        

      </div>
      {String(vehicle.arhiv).toUpperCase() === "ОТГРУЖЕНО" ? (
          <div>
            <p class={s.otgruzheno}>ОТГРУЖЕНО</p>
          </div>
        ) : null}

<div className={s.myCarouselContainer}>

 

  <div 
    className={s.carouselWrapper}
    onTouchStart={handleCarouselTouchStart}
    onTouchEnd={handleCarouselTouchEnd}
  >
    <div 
      className={s.carouselInner}
      style={{ transform: `translateX(-${currentIndex * (slideWidth / 3)}px)` }}
    >
      {photoList.map(({ src, label }, idx) => (
        <div 
          className={s.slideBlock}
          key={idx}
          style={{ width: "125px", margin: "0 5px"}}
        >
          <img
            src={src}
            alt={label}
            className={s.photo}
            onClick={() => openModal(idx)}
          />
          <div className={s.labelOverlay}>{label}</div>
        </div>
      ))}
    </div>
  </div>

 
  
</div>

{/* Индикатор 1 / N */}
<div className={s.customPagination}>
<button onClick={prevSlide} className={s.arrowButton}>←</button>
  {currentIndex + 1} / {photoList.length}
  <button onClick={nextSlide} className={s.arrowButton}>→</button>
</div>





      
<h3 className={s.infoBlock_head}>Общая информация</h3>
      {/* Основная информация */}
      <div className={s.infoBlock}>
        
        <p className={s.infoBlock_p_left}>VIN: </p><p className={s.infoBlock_p_right}><strong>{vehicle.vin}</strong></p>
        <p className={s.infoBlock_p_left}>Дата поступления: </p><p className={s.infoBlock_p_right}><strong>{vehicle.date_acceptance ? vehicle.date_acceptance.split("-").reverse().join("-") : "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Марка:</p><p className={s.infoBlock_p_right}><strong>{vehicle.brand ?? "-"}</strong> </p>
        <p className={s.infoBlock_p_left}>Модель: </p><p className={s.infoBlock_p_right}><strong>{vehicle.model ?? "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Тип ТС: </p><p className={s.infoBlock_p_right}><strong>{vehicle.vehicle_type ?? "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Цвет: </p><p className={s.infoBlock_p_right}><strong>{vehicle.color ?? "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Пробег: </p><p className={s.infoBlock_p_right}><strong>{vehicle.mileage ? `${vehicle.mileage} км` : "-"}</strong></p>
        {/* <p className={s.infoBlock_p_left} style={{ fontWeight: vehicle.vehicle_status === "Готов" ? "bold" : "normal", color: vehicle.vehicle_status === "Готов" ? "green" : "black" }}>
          Статус:</p><p className={s.infoBlock_p_right}><strong>{vehicle.vehicle_status ?? "-"}</strong> 
        </p> */}

          <p className={s.infoBlock_p_left}>Статус:</p>
          {vehicle.vehicle_status === "Готов" ? (
            <div className={s.vehicle_status_div}>
              <img src="/shape_status.svg" alt="icon" width={16} height={16} />
              <p className={s.statusReady}>{vehicle.vehicle_status}</p>
            </div>
          ) : (
            <p className={s.infoBlock_p_right}><strong>-</strong></p>
          )}

      </div>
<h3 className={s.infoBlock_head}>Дополнительная информация</h3>
      {/* Дополнительная информация */}
      <div className={s.dop_infoBlock}>
          <div className={s.dop_div}>
            <p className={s.dop_infoBlock_p_left}>Комплектация: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.configuration ?? "-"}</strong></p>
        </div>
        
        <div className={s.dop_div}>
          <p className={s.dop_infoBlock_p_left}>Недостатки по комплектности: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.completeness_defects ?? "-"}</strong></p>
        </div>
        
        <div className={s.dop_div}>
          <p className={s.dop_infoBlock_p_left}>Дефекты: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.defects ?? "-"}</strong></p>
        </div>

        <div className={s.dop_div}>
          <p className={s.dop_infoBlock_p_left}>Ошибки: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.errors ?? "-"}</strong></p>
        </div>

        <div className={s.dop_div}>
         <p className={s.dop_infoBlock_p_left}>План работ: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.service_plan ?? "-"}</strong></p> 
        </div>

        <div className={s.dop_div}>
          <p className={s.dop_infoBlock_p_left}>Результат работ: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.service_result ?? "-"}</strong></p>
        </div>
       
        <div className={s.dop_div}>
          <p className={s.dop_infoBlock_p_left}>Гарантийные работы: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.warranty_work ?? "-"}</strong></p>
        </div>
        
        <div className={s.dop_div}>
          <p className={s.dop_infoBlock_p_left}>ТО: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.maintenance ?? "-"}</strong></p>
        </div>

        <div className={s.dop_div}>
          <p className={s.dop_infoBlock_p_left}>Примечания: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.note ?? "-"}</strong></p>
        </div>
        <div className={s.dop_div}>
          <p className={s.dop_infoBlock_p_left}>Техническое задание: </p><p className={s.dop_infoBlock_p_right}><strong>{vehicle.technical_task ?? "-"}</strong></p>
        </div>
          </div>


<h3 className={s.infoBlock_head}>История обслуживания</h3>
      {/* Даты выполнения работ */}
      <div className={s.infoBlock}>
        
        <p className={s.infoBlock_p_left}>Дата заявки: </p><p className={s.infoBlock_p_right}><strong>{vehicle.request_date ? vehicle.request_date.split("-").reverse().join("-") : "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Дата мойки (снаружи): </p><p className={s.infoBlock_p_right}><strong>{vehicle.washing_exterior ? vehicle.washing_exterior.split("-").reverse().join("-") : "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Дата мойки (кабина): </p><p className={s.infoBlock_p_right}><strong>{vehicle.washing_cabin ? vehicle.washing_cabin.split("-").reverse().join("-") : "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Дата установки УВЭОС: </p><p className={s.infoBlock_p_right}><strong>{vehicle.uv_installation ? vehicle.uv_installation.split("-").reverse().join("-") : "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Дата отключения AdBlue: </p><p className={s.infoBlock_p_right}><strong>{vehicle.adblue_disable ? vehicle.adblue_disable.split("-").reverse().join("-") : "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Дата установки маяка: </p><p className={s.infoBlock_p_right}><strong>{vehicle.leasing_beacon_installation ? vehicle.leasing_beacon_installation.split("-").reverse().join("-") : "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Дата отгрузки: </p><p className={s.infoBlock_p_right}><strong>{vehicle.shipment_date ? vehicle.shipment_date.split("-").reverse().join("-") : "-"}</strong></p>
        <p className={s.infoBlock_p_left}>Менеджер: </p><p className={s.infoBlock_p_right}><strong>{vehicle.manager ?? "-"}</strong></p>
      </div>
      <div className={s.footter_freespace}>
       
       
        {/* <img
          src={photoList[0]?.src}
          alt="Фото"
          className={s.modalImage}
        /> */}
        
      
</div>


      <div className={s.footter_buttons}>

          {role === "superadmin" || role === "admin" || role === "full" ? (
                                <div className={s.trash_div} onClick={() => handleDeleteClick()}>
                                  <FontAwesomeIcon className={s.trash_icon} icon={faTrash} size="lg" color="#181B1E"/>
                                  <p>Удалить</p>
                                </div>
                              ) : null}

{role === "superadmin" || role === "admin" || role === "full" || role === "prefull" || role === "office-manager" || role === "service" ? (
                        <Link key={id} to={`/update/${id}`} className={s.pan_button}>
                          <svg
                              width="18"
                              height="18"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ marginRight: "6px" }} // ⬅ немного отступа от текста
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M14 1.5L19 6.5L6 19.5H1V14.5L14 1.5V1.5Z"
                                stroke="currentColor" // ⬅ чтобы цвет подстраивался под CSS
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                        <p>Редактировать</p>
                          </Link>
                      ) : null}


      </div>

      <Modal
  isOpen={modalOpen}
  onRequestClose={closeModal}
  className={s.modalContent}
  overlayClassName={s.modalOverlay}
  appElement={document.getElementById("root")}
>
  {/* Слой, ловящий свайпы */}
  <div
    className={s.modalWrapper}
    onTouchStart={handleTouchStart}
    onTouchEnd={handleTouchEnd}
  >
    {photoList.length > 0 && selectedPhotoIndex !== null && (
      <>
        {/* Изображение без перехвата касания */}
        <img
          src={photoList[selectedPhotoIndex]?.src}
          alt="Фото"
          className={s.modalImage}
        />
        <div className={s.div_buttons_foto}>
          <button onClick={prevPhoto} className={s.navButton}>←</button>
          <button onClick={nextPhoto} className={s.navButton}>→</button>
        </div>
        <button onClick={closeModal} className={s.closeButton}>✖</button>
      </>
    )}
  </div>
</Modal>

          {/* Модальное окно подтверждения удаления */}
                    {showModal_del && (
                      <div className={s.modalOverlay_del}>
                        <div className={s.modalContent_del}>
                          <h3>Удалить автомобиль?</h3>
                          <p><strong>{vehicle.vin}</strong></p>
                          <p>{vehicle.brand} - {vehicle.vehicle_type}</p>
                          {error && <p className={s.error}>{error}</p>}
                          <div className={s.modalButtons_del}>
                            <button onClick={handleDeleteVehicle} className={s.confirmButton_del}>Удалить</button>
                            <button onClick={handleCloseModal} className={s.cancelButton_del}>Отмена</button>
                          </div>
                        </div>
                      </div>
                    )}
    </div>

          
  );
};

export default VehicleDetails;
